import classNames from 'helpers/class-names'
import { HTMLAttributes, RefObject, forwardRef } from 'react'

interface Props extends HTMLAttributes<HTMLTableSectionElement> {}

export const TableHeader = forwardRef(
  ({ children, ...props }: Props, ref: RefObject<HTMLTableSectionElement>) => {
    // Can't use border because when the table scrolls and the table header
    // becomes sticky, borders disappear. Box shadow persists.
    const style = { boxShadow: '0 0.5px 0 #c4c7d4' }

    return (
      <thead
        {...props}
        ref={ref}
        className={classNames('sticky top-0 z-10 bg-gray-50', props.className)}
        style={style}>
        {children}
      </thead>
    )
  },
)
